export default {
  restaurantabout2: {
    subtitle: "FOR RESTAURANTS",

    title1: "Order Smarter",
    title2: "Spend Less.",

    desc:
      "MAHAL helps restaurants simplify procurement by connecting them directly with verified suppliers for daily and bulk sourcing.",

    text:
      "MAHAL works with a wide network of suppliers — from local farms to large-scale distributors — ensuring restaurants always get quality ingredients, fair pricing, and reliable long-term sourcing through a single trusted platform.",

    li1: "Direct access to verified suppliers",
    li2: "Transparent & competitive pricing",
    li3: "Daily & bulk ordering in one place",
    li4: "Track orders & manage deliveries",

    btn1: "Go to Restaurant Portal",
    btn2: "View Ongoing Deals",
  },
};